var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYinhao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755479469766,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14344,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M859.4785015 812.42836443l-292.68851504 0 0-211.08062938c0-86.08885109 7.46827573-153.71069312 22.40482718-202.66184586 14.93655145-49.01904613 30.48414364-81.74367248 71.08440623-120.91817332s68.77603009-50.98795518 128.45434248-66.2639737L830.42011959 301.12305087c-41.68655724 15.88705927-67.01080129 23.01586793-106.18530214 63.61613051-39.24239426 40.53236917-42.09391773 79.84265685-42.09391773 113.58568443L859.4785015 478.32486582 859.4785015 812.42836443z m-402.60795504-1e-8l-292.62062163 0 0-211.08062937c0-86.08885109 7.46827573-153.71069312 22.40482719-202.66184586 14.93655145-49.01904613 30.48414364-81.74367248 71.08440622-120.91817332 40.60026259-39.24239427 68.77603009-51.05584861 128.38644908-66.33186714l41.68655722 89.61930873c-41.68655724 15.9549527-67.07869471 23.01586793-106.18530213 63.6161305-39.17450086 40.60026259-42.02602432 79.91055027-42.02602431 113.65357786L456.93843987 478.32486581 456.93843987 812.42836443l-0.06789341 0z",
    "p-id": 14345,
    fill: "#2e5154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYinhao);
export default __webpack_public_path__ + "static/media/yinhao.c724e87a.svg";
export { ForwardRef as ReactComponent };